import React, { useCallback, useContext, useEffect } from "react";

//Data contexts
import { EducationFormContext } from "../hooks/EducationFormContext";

//React components
import { EducationSelector } from "./EducationSelector";
import { GoalAchievementTarget } from "../interview_goals/components/GoalAchievementTarget";
import { GoalAchievementThreshold } from "../interview_goals/components/GoalAchievementThreshold";
import { GoalOccurrence } from "../common/components/GoalOccurrence";
import { GoalNameInput } from "../common/components/GoalNameInput";
import { ParentInterviewSelector } from "./ParentInterviewSelector";

//JS Classes
import { EducationGoalTemplate } from "../classes/goal_template_education_class";
import { EducationFormPropsShape } from "../interfaces/componentTypes";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { GoalDescriptionInput } from "../common/components/GoalDescriptionInput";
import { LeaderBoardSelector } from "../common/components/LeaderBoardSelector";

export const EducationForm: React.FunctionComponent<EducationFormPropsShape> = ({
  setStepComplete,
}) => {
  const { DBObject } = useContext(TMDataContext);
  const { goalState, setGoalState } = useContext(EducationFormContext);

  useEffect(() => {
    setStepComplete(EducationGoalTemplate.complete(goalState));
  }, [goalState]);

  useEffect(() => {
    var newSelector = document.getElementById("goal-frequency-selector");
    newSelector.addEventListener("keydown", (event) => {
      if (
        (!goalState.occurrenceFrequency ||
          $(newSelector).val() == goalState.occurrenceFrequency.id) &&
        event.key == "Enter"
      ) {
        event.preventDefault();
      }
    });
  }, []);

  const handleGoalName = useCallback((e) => {
    e.persist();
    setGoalState((prevState) => {
      return {
        ...prevState,
        name: e.target.value,
      };
    });
  }, []);

  const handleGoalDescription = useCallback((e) => {
    e.persist();
    setGoalState((prevState) => {
      return {
        ...prevState,
        description: e.target.value,
      };
    });
  }, []);

  const handleLeaderboardSelection = useCallback((value) => {
    value.persist();
    setGoalState((prevState) => {
      return {
        ...prevState,
        leaderboardEnabled: value.target.checked,
      };
    });
  }, []);

  return (
    <>
      <div className="row wor-100" style={{ flex: 1 }}>
        <div className="col-md-12 col-sm-6">
          <GoalNameInput
            handleGoalName={handleGoalName}
            input={goalState.name}
            user={goalState.user}
            type={goalState.type}
            characterLimit={DBObject.ConfigVariables.goal_name_character_limit}
          />
          <GoalDescriptionInput
            input={goalState.description}
            handleGoalDescription={handleGoalDescription}
            characterLimit={DBObject.ConfigVariables.goal_name_character_limit}
          />
          <ParentInterviewSelector />
          <EducationSelector />
          <GoalAchievementTarget contextOrigin={EducationFormContext} />
          <GoalAchievementThreshold contextOrigin={EducationFormContext} />
          <GoalOccurrence
            approved={true}
            contextOrigin={EducationFormContext}
          />
          {DBObject.ConfigVariables.leaderboards_enabled == "true" ? (
            <LeaderBoardSelector
              handleLeaderboardSelection={handleLeaderboardSelection}
              leaderboardStatus={goalState.leaderboardEnabled}
              approved={true}
            />
          ) : null}
        </div>
      </div>
    </>
  );
};
